import { EAsyncStatus } from '../../../common/types/asyncStatus';
import { IMapState } from '../../types';

export function selectFeaturesStatus(state: IMapState): EAsyncStatus {
  const { activeType, data } = state.map.infrastructure;

  if (!activeType) {
    return EAsyncStatus.Initial;
  }

  return data[activeType].featuresStatus;
}
